import * as React from "react";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ModernBirthdayCalendar, formatDateForStorage, parseDateFromStorage } from "./modern-birthday-calendar";

export { formatDateForStorage, parseDateFromStorage };

interface BirthdayDatePickerProps {
  value?: Date;
  onChange?: (date: Date | undefined) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  disabledDates?: (date: Date) => boolean;
}

export function BirthdayDatePicker({
  value,
  onChange,
  placeholder = "Pick a date",
  className,
  disabled,
  disabledDates,
}: BirthdayDatePickerProps) {
  const [open, setOpen] = React.useState(false);

  const handleSelect = (date: Date | undefined) => {
    onChange?.(date);
    setOpen(false);
  };

  const defaultDisabledDates = (date: Date) => {
    // Disable future dates for birthdays
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date > today || (disabledDates ? disabledDates(date) : false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "w-full justify-start text-left font-normal",
            !value && "text-muted-foreground",
            className
          )}
          disabled={disabled}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {value ? value.toLocaleDateString() : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <ModernBirthdayCalendar
          selected={value}
          onSelect={handleSelect}
          disabled={defaultDisabledDates}
        />
      </PopoverContent>
    </Popover>
  );
}